module.exports = __webpack_public_path__ + "img/LT301788649.faf8f87f.png";